var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('GenericField',{attrs:{"value":_vm.value,"field":_vm.field,"items":_vm.computedItems,"classes":_vm.classes,"clearable":""},on:{"input":_vm.updateValue}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }